// ----------------------------------------------------------------------
let userDetail = JSON.parse(localStorage.getItem("security_auth"))
const account = {
  displayName: userDetail !== null && userDetail.name,
  email: userDetail !== null && userDetail.email,
  photoURL: userDetail !== null && userDetail.profile_img !== null ? userDetail.profile_img : '/static/default-user-icon.svg',
};

export default account;
